import Swal from "sweetalert2";

const swal = Swal.mixin({
  cancelButtonColor: "#c40d42",
  confirmButtonColor: "#164396",
});

const swalDelete = swal.mixin({
  title: "Alert",
  text: "This action cannot be undone. Are you sure you want to proceed and delete the data?",
  icon: "warning",
  showCancelButton: true,
  showLoaderOnConfirm: true,
  allowOutsideClick: () => !swal.isLoading(),
});

const swalDeleteWithList = ({
  items,
  preConfirm,
}: {
  items: string[];
  preConfirm: () => unknown;
}) => {
  const selecteds = items.map((item) => `<li>${item}</li>`).join("");
  const html = `
<p>This action cannot be undone. Are you sure you want to proceed and delete the data?</p>
<div style="text-align: start; margin-top: 1em; border: 1px solid black; max-height: 8em; overflow: auto;">
<p>These will be deleted:</p>
<ul style="list-style: disc; list-style-position: inside;">${selecteds}</ul>
</div>
`;
  return swalDelete.fire({
    html,
    preConfirm,
  });
};

const swalSuccess = swal.mixin({
  title: "Success",
  icon: "success",
});

const swalError = swal.mixin({
  title: "Sorry",
  icon: "error",
});

const swalErrorDefault = swalError.mixin({
  text: "Something went wrong, please try again.",
});

const swalLoading = swal.mixin({
  title: "In progress",
  text: "Please wait...",
  showConfirmButton: false,
  willOpen: () => {
    swal.showLoading();
  },
});

const swalSuccessEditDefault = swalSuccess.mixin({
  title: "Edit data successfull",
  text: "You have successfully edit data.",
});

const swalErrorEditDefault = swalError.mixin({
  title: "Edit data failed",
  text: "Edit data failed, please try again.",
});

const swalWithInputText = swal.mixin({
  input: "text",
  inputAttributes: {
    autocapitalize: "off",
  },
});

const swalWarningDefault = swal.mixin({
  icon: "warning",
  title: "Alert",
  text: "This Action cannot be undone. Are you sure want to continue this Action?",
  showCancelButton: true,
});

function alertConfirmationReject(
  preConfirmCallback: (notes: string) => void,
  {
    minRemarksLength,
    title,
    text,
    inputPlaceholder = "Remarks",
  }: {
    minRemarksLength?: number;
    title?: string;
    text?: string;
    inputPlaceholder?: string;
  } = {},
) {
  swalWithInputText.fire({
    icon: "warning",
    title: title ?? "Reject",
    text: text ?? "Please write remarks to reject",
    confirmButtonText: "OK",
    showLoaderOnConfirm: true,
    showCancelButton: true,
    cancelButtonColor: "#aaa",
    allowOutsideClick: false,
    input: "textarea",
    inputPlaceholder: inputPlaceholder,
    inputValidator: async (value) => {
      if (!value?.trim()) {
        return `A ${inputPlaceholder} is required`;
      }
      if (minRemarksLength) {
        const alphanumericCharCount = value.replace(/[^a-zA-Z0-9]/g, "").length;
        if (alphanumericCharCount < minRemarksLength) {
          return `The ${inputPlaceholder} must contain at least ${minRemarksLength} alphanumeric characters (spaces and special characters are not counted)`;
        }
      }
      return null;
    },
    preConfirm: (notes) => {
      preConfirmCallback(notes);
    },
  });
}

export {
  swal,
  swalDelete,
  swalSuccess,
  swalError,
  swalErrorDefault,
  swalLoading,
  swalDeleteWithList,
  swalSuccessEditDefault,
  swalErrorEditDefault,
  swalWithInputText,
  swalWarningDefault,
  alertConfirmationReject,
};
